import { ChartData } from '../../../shared/types/game.types';

/**
 * 새로운 캔들 데이터를 랜덤으로 생성 (서버 데이터가 없을 때 사용)
 */
export const generateNewCandle = (
  basePrice: number,
  lastTimestamp: number
): ChartData => {
  const volatility = 0.025 + Math.random() * 0.015;
  const trend = Math.sin(Date.now() * 0.0005) * 0.002;
  const change = (Math.random() - 0.5) * volatility + trend;
  const openGap = (Math.random() - 0.5) * 0.01;
  const open = basePrice * (1 + openGap);
  const close = open * (1 + change);
  const high = Math.max(open, close) * (1 + Math.random() * 0.012);
  const low = Math.min(open, close) * (1 - Math.random() * 0.012);
  const volume = Math.floor(Math.random() * 12000) + 3000;
  const changeAmount = close - open;
  const changePercent = (changeAmount / open) * 100;
  const isUp = close >= open;
  const newTimestamp = lastTimestamp + 60000;

  return {
    timestamp: newTimestamp,
    open,
    high,
    low,
    close,
    volume,
    change: changeAmount,
    changePercent,
    time: new Date(newTimestamp).toLocaleTimeString(),
    isUp,
  };
};

